import { CheckHeaders } from './check-headers'
import { getBrowserData } from './get-browsers-data'

export const NikitaHeadersNames = {
  HASH: 'X-Fingerprint',
  LOCAL_IP: 'X-Local-IP',
  SESSION: 'X-Session',
  BROWSER: 'X-Browser',
  VERSION: 'X-Version',
} as const

export type NikitaHeaders = {
  [key in (typeof NikitaHeadersNames)[keyof typeof NikitaHeadersNames]]?: string
}

export const getNikitaHeaders = async (sidUrl: string) => {
  const checker = new CheckHeaders(sidUrl)
  const response = await Promise.all([checker.init(), getBrowserData()])
  const twistoJSHeaders = checker.getHeaders()

  return {
    ...twistoJSHeaders,
    [NikitaHeadersNames.BROWSER]: JSON.stringify(response[1]),
  }
}
